import { camelCase } from 'lodash';

const amenities = {
  byBeach: (beach) => {
    const table = {
      fiLighthouse: [
        {
          icon: 'shopping',
          text: 'Shopping',
        },
      ],
      kismet: [
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
      ],
      saltaire: [
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'postoffice',
          text: 'Post Office',
        },
        {
          icon: 'restrooms',
          text: 'Restrooms',
        },
      ],
      fairHarbor: [
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
        {
          icon: 'postoffice',
          text: 'Post Office',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
      ],
      atlantique: [
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
      ],
      dunewood: [
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
      ],
      oceanBeach: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'postoffice',
          text: 'Post Office',
        },
        {
          icon: 'restrooms',
          text: 'Restrooms',
        },
        {
          icon: 'restaurant',
          text: 'Restaurants',
        },
        {
          icon: 'hotel',
          text: 'Hotels',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
      ],
      seaview: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
      ],
      oceanBayPark: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'restaurant',
          text: 'Restaurants',
        },
        {
          icon: 'hotel',
          text: 'Hotels',
        },
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
      ],
      pointOWoods: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
      ],
      sailorsHavenSunkenForest: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
        {
          icon: 'swimming',
          text: 'Swimming',
        },
        {
          icon: 'picnic',
          text: 'Picnic',
        },
      ],
      cherryGrove: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
        {
          icon: 'hotel',
          text: 'Hotel',
        },
        {
          icon: 'postoffice',
          text: 'Post Office',
        },
      ],
      fiPines: [
        {
          icon: 'grocery',
          text: 'Grocery Store',
        },
        {
          icon: 'marina',
          text: 'Marina',
        },
        {
          icon: 'restaurant',
          text: 'Restaurant',
        },
        {
          icon: 'hotel',
          text: 'Hotel',
        },
        {
          icon: 'postoffice',
          text: 'Post Office',
        },
      ],
      waterIsland: [
        {
          icon: 'anchorage',
          text: 'Anchorage',
        },
      ],
    };
    return table[camelCase(beach.replace(/[^\w\s]/gi, ''))];
  },
};

export default amenities;
